export function isCypressTest() {
    return (typeof window["CYPRESS_TEST"] !== "undefined" &&
        window["CYPRESS_TEST"] === "true");
}
